import { take, call, fork, put } from 'redux-saga/effects';
import FormData from 'form-data';

import * as actUploaders from '../../actions/uploaders';
import * as actionBtn from '../../actions/buttons';
import * as action from '../../actions';
import * as actCustomerList from '../../actions/customers/list';
import { DO_IMPORT_CUSTOMER } from '../../actions/uploaders/constants';

import { postNewFile } from '../../api/s3';
import * as api from '../../api/uploaders';
import { CUSTOMER } from '../../utils/uploadS3Constants';
import { assertErrorHasData } from '../../utils/assert';
import * as clevertapCustomersList from '../../clevertap/customers/list';
import { getProfile } from '../api/profile';

function wait(millis) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, millis);
  });
}

export function* getImportedStatus() {
  // noinspection InfiniteLoopJS
  while (true) {
    let stop = false;
    // noinspection InfiniteLoopJS
    while (!stop) {
      yield call(wait, 5000);
      const profile = yield call(getProfile);
      if (!profile.importing) {
        stop = true;
        return true;
      }
    }
  }
}

/**
 * Ini kalo direfactor
 * ensure clevertapnya ikutan direfactor
 */
export function* doImportCustemers() {
  while (true) {
    const request = yield take(DO_IMPORT_CUSTOMER);
    clevertapCustomersList.customerListImport();
    const { file, hasLoyalty } = request.payload;
    yield put(action.sendingRequest(true));
    yield put(action.showLoadingSpinner(true));
    yield put(actionBtn.showLoadingButton(true));

    const formData = new FormData();
    formData.append('file', file);
    formData.append('namespace', CUSTOMER);

    try {
      yield put(actUploaders.showModalImport(false));
      const response = yield call(postNewFile, formData);
      const { data } = response;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const payload = { file_url: data.download_file_url };
      yield call(api.customerServiceImport, payload);

      yield put(action.showLoadingSpinner(false));
      yield put(actCustomerList.showImportingModeModal());
      yield call(getImportedStatus);

      const customersReqParam = { page: 1 };
      if (hasLoyalty) {
        (customersReqParam as any).type = 'ALL';
      }
      yield put(actCustomerList.customersRequest(customersReqParam, []));
      yield put(actCustomerList.setCustomerDetail(null));
      yield put(actCustomerList.hideImportingModeModal());
    } catch (error) {
      assertErrorHasData(error);
      const errors = error.data.errors.map((err) => err.user_message);
      yield put(actUploaders.showModalErrorImport(true, errors));
      yield put(action.showLoadingSpinner(false));
    } finally {
      yield put(action.sendingRequest(false));
      yield put(actionBtn.showLoadingButton(false));
    }
  }
}

export default function* importCustomers() {
  yield fork(doImportCustemers);
}
